<script setup lang="ts">
defineProps<{ reporter?: string; assignee: string; shortcut: string }>();
</script>

<template>
  <div>
    <span>{{ assignee }}</span>
    <span class="shortcut">{{ shortcut }}</span>
  </div>
  <div v-if="reporter">{{ reporter }}</div>
</template>
